export interface IColumn {
    field?: string;
    header: string;
    width?: string;
    fieldName?: string;
    canSort?: boolean;
    isVisible?: boolean;
    cssClass?: string;
}
